import React, { FunctionComponent, HTMLAttributes, PropsWithChildren } from 'react';

import cn from 'classnames';

import css from './styles.css';

export type IslandProps = PropsWithChildren<Pick<HTMLAttributes<HTMLDivElement>, 'className'>>;

export const Island: FunctionComponent<IslandProps> = ({ className, children }) => {
    const islandClasses = cn(css.island, className);

    return <div className={islandClasses}>{children}</div>;
};
